<template>
  <div id="register-try">
    <div id="container">
      <div id="content">
        <div id="page-title">
          <img :src="getImage('component/common/header/daros_logo_black.svg')" width="300px" height="auto"/>
          <p class="sentence1">Domans Automatic Realization & Operation System</p>
          <p class="sentence2">無料体験版登録</p>
        </div>
        <button type="button" class="main_btn" @click="showNewUserModal">メールアドレス登録</button>
        <!-- 仮登録モーダル -->
        <div id="new-user-modal" class="modal" v-show="newUserModalShown">
          <div class="modal-main new-user-modal">
            <div class="title-area">
              <h2>ユーザー個人登録</h2>
            </div>
            <div class="message">
              フォームよりメールアドレスを入力して仮登録を行ってください。<br>
              仮登録したメール宛に本会員登録手続きのご案内メールを自動送信いたします。<br>
              ご案内メールに記載されたURLより本登録を行ってください。
            </div>
            <div class="input-area">
              <div class="error_message">{{ userErrorMessage.text }}</div>
              <ul>
                <li>
                  <span class="label">メールアドレス/ログインID：</span>
                  <input type="text" v-model="userEmail" placeholder="メールアドレス/ログインID">
                  <div class="error_message">{{ validateUserErrorMessages.userEmail }}</div>
                </li>
              </ul>
            </div>
            <div class="caution">
              ※受信制限をされている方は、「@domans.co.jp」からのメールを受信許可に設定してください。<br>
              ※メールアドレスを間違えて入力してしまった場合は、再度仮登録手続きを行ってください。<br>
              ※受信が確認できない場合、念の為迷惑メールフォルダのご確認をお願いします。
            </div>
            <div class="button-area">
              <button type="button" class="main_btn" v-bind:class="{img_disable: submitDisable}" @click="submitNewUser">登録</button>
              <button type="button" class="main_btn" @click="closeNewUserModal">キャンセル</button>
            </div>
          </div>
        </div>
        <!-- 仮登録完了モーダル -->
        <div id="complete-new-user-modal" class="modal" v-show="completeNewUserModalShown">
          <div class="modal-main complete-new-user-modal">
            <div class="title-area">
              <h2>仮登録完了</h2>
            </div>
            <div class="complete-message">
              仮登録いただきありがとうございます。<br>
              ご入力いただいたアカウントはまだ本登録が完了しておりません。<br>
              引き続き、ご案内メールより本登録を行ってください。<br>
              ※受信制限をされている方は、「@domans.co.jp」からのメールを受信許可に設定してください。<br>
              ※メールアドレスを間違えて入力してしまった場合は、再度仮登録手続きを行ってください。<br>
              ※受信が確認できない場合、念の為迷惑メールフォルダのご確認をお願いします。
            </div>
            <div class="button-area">
              <button type="button" class="main_btn complete_btn" @click="closeCompleteNewUserModal">OK</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- ローディングモーダル -->
    <dd-loading-modal ref="loadingModalRef" />
    <!-- フッター -->
    <dd-footer />
  </div>
</template>
<script>
import axios from 'axios'
import {API_URL} from '../constants/App'
import * as Api from '../utils/Api'
import * as App from '../utils/App'
import LoadingModal from '../components/common/LoadingModal'
import Footer from '../components/common/Footer'

export default {
  name: 'RegisterTry',
  components: {
    'dd-loading-modal': LoadingModal,
    'dd-footer': Footer
  },
  data () {
    return {
      // *****************************************************************
      // ユーザー個人登録
      // *****************************************************************
      userEmail: '',
      newUserModalShown: false,
      completeNewUserModalShown: false,
      userErrorMessage: { text: '' },
      validateUserErrorMessages: {
        userEmail: ''
      },
      submitDisable: false
    }
  },
  methods: {
    // *****************************************************************
    // ユーザー個人登録
    // *****************************************************************
    showNewUserModal: function () {
      this.userEmail = ''
      this.newUserModalShown = true
      // this.$emit('onShowModal')
    },
    closeNewUserModal: function () {
      this.clearUserMessage()
      this.newUserModalShown = false
      this.$emit('onCloseModal')
    },
    submitNewUser: function () {
      this.submitDisable = true
      this.clearUserMessage()
      let payload = {
        userEmail: this.userEmail
      }
      this.$refs.loadingModalRef.showModal(true)
      axios.post(API_URL.ADMIN + '/new-trial-user', payload
      ).then(response => {
        this.$refs.loadingModalRef.showModal(false)
        this.completeNewUserModalShown = true
        this.newUserModalShown = false
      }).catch(error => {
        this.$refs.loadingModalRef.showModal(false)
        Api.handleError(error, this.userErrorMessage, this.validateUserErrorMessages)
      }).finally(() => {
        this.submitDisable = false
      })
    },
    clearUserMessage: function () {
      this.userErrorMessage = { text: '' }
      this.validateUserErrorMessages = { userEmail: '' }
    },
    closeCompleteNewUserModal: function () {
      this.completeNewUserModalShown = false
    },
    getImage: function (image) {
      return App.getDarosResource(image)
    }
  },
  created: function () {
  }
}
</script>
<style lang="scss" scoped>
#register-try {
  background: #eee;
  height: calc(100% - 51px);
  min-height: 260px;
  min-width: 500px;
}
#container {
  height: 100%;
  display: flex;
  justify-content: center;
}
#content {
  padding-top: 80px;
  text-align: center;
  display: block;
  form {
    padding: 20px 50px;
    border-radius: 5px;
    background-color: #fff;
    input {
      width: 200px;
    }
  }
}
#page-title {
  margin-bottom: 66px;
  p {
    margin-top: 10px;
  }
  .sentence1 {
    font-size: 12.75px;
  }
  .sentence2 {
    font-size: 42px;
    font-weight: 500;
  }
}
#new-user-modal {
  font-size: 15px;
  font-weight: normal;
  span.label {
    text-align: right;
    display: inline-block;
    min-width: 120px;
    font-weight: bolder;
  }
}
.new-user-modal{
  max-width: 588px;
}
.modal .modal-main .input-area {
  padding: 13px 10px 10px 35px;
  li {
    margin-bottom: 0;
  }
}
.complete-new-user-modal {
  max-width: 588px;
}
.message {
  text-align: left;
  margin: 14px 0 0 15px;
  font-size: 13px;
}
.caution {
  text-align: left;
  margin: 19px 0 14px 15px;
  font-size: 13px;
}
.complete-message {
  text-align: left;
  margin: 15px 0 19px 15px;
  font-size: 13px;
}
.complete_btn {
  background: #ff4500;
  padding: 1px 20px;
  &:hover {
    cursor: pointer;
    background: #ff4500;
    color: #323232;
  }
}

</style>



// WEBPACK FOOTER //
// src/main/js/pages/RegisterTry.vue